import * as R from 'ramda';
import { all, select, fork, cancel, race, call, put, take, takeEvery, takeLatest, cancelled } from 'redux-saga/effects';
import entityActions from '../../genericActions/entityActions';
import db from '../../db/db';

const getAllSaga = function* (keyWindow) {
  try {
    const connections = yield call(db.connections.toArray.bind(db.connections));
    yield put(entityActions.receiveEntities(
      keyWindow,
      { type: 'connections', byId: R.indexBy(R.prop('id'), connections), ids: R.pluck('id')(connections) },
    ));
  } catch (e) {
    console.error(e);
  }
};

const addSaga = function* (action) {
  const connection = action.payload.data;
  const keyWindow = action.payload.keyWindow;
  try {
    const id = yield call(db.connections.add.bind(db.connections), {
      name: connection.name,
      shortName: connection.shortName,
      color: connection.color,
      bearerToken: connection.bearerToken,
      betaApiKey: connection.betaApiKey,
      description: connection.description,
    });

    const ids = yield select(store => R.pathOr([], ['connection', keyWindow, 'ids'], store));
    yield put(entityActions.receiveEntities(
      keyWindow,
      { type: 'connections', byId: { [id]: { ...connection, id } }, ids: R.uniq([...ids, id]) },
    ));
  } catch (e) {
    console.error(e);
  }
};

const updateSaga = function* (action) {
  const connection = action.payload.data;
  const keyWindow = action.payload.keyWindow;
  try {
    yield call(db.transaction.bind(db), 'rw', [db.connections], async () => {
      db.connections
        .where('id')
        .equals(connection.id)
        .modify({
          name: connection.name,
          shortName: connection.shortName,
          color: connection.color,
          bearerToken: connection.bearerToken,
          betaApiKey: connection.betaApiKey,
          description: connection.description,
        })
      ;
    });

    const ids = yield select(store => R.pathOr([], ['connection', keyWindow, 'ids'], store));
    yield put(entityActions.receiveEntities(
      keyWindow,
      {
        type: 'connections',
        byId: { [connection.id]: connection },
        ids: R.uniq([...ids, connection.id]),
      },
    ));
  } catch (e) {
    console.error(e);
  }
};

const deleteSaga = function* (action) {
  const connectionId = action.payload.id;
  const keyWindow = action.payload.keyWindow;

  try {
    yield call(db.transaction.bind(db), 'rw', [db.connections, db.tabs, db.categories, db.queries], async () => {
      const tabs = await db.tabs.where('connectionId').equals(connectionId).toArray();
      await db.categories.where('tabId').anyOf(tabs.map(tab => tab.id)).delete();
      await db.queries.where('tabId').anyOf(tabs.map(tab => tab.id)).delete();
      await db.tabs.where('connectionId').equals(connectionId).delete();
      await db.connections.delete(connectionId);
    });

    const ids = yield select(store => R.pathOr([], ['connection', keyWindow, 'ids'], store));
    yield put(entityActions.receiveEntities(
      keyWindow,
      { type: 'connections', ids: R.difference(ids, [connectionId]) },
    ));
  } catch (e) {
    console.error(e);
  }
};

export default {
  getAllSaga,
  addSaga,
  deleteSaga,
  updateSaga,
};
